import { i18n } from '@/utils/i18n';
import _, { AxiosRequestHeaders, AxiosResponse } from 'axios';
import { getErrorInfo } from '@/utils/serviceUtil';
const { t } = i18n;
const Axios = () => {
  let _errorMessage = '';
  let _errorCode = '';
  let _isAxiosError = false;

  const axiosInstance = _.create({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
    },
  });

  const get = <D, T>(url: string, params?: D): Promise<AxiosResponse<T>> => {
    return axiosInstance.get(url, { params });
  };

  const post = <D, T>(url: string, params?: D, extraHeader?: any): Promise<AxiosResponse<T>> => {
    return axiosInstance.post(url, params, { headers: extraHeader });
  };

  const getErrorMessage = () => {
    return _errorMessage;
  };

  const getErrorCode = () => {
    return _errorCode;
  };

  const getIsAxiosError = () => {
    return _isAxiosError;
  };

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (_.isAxiosError(error)) {
        const { displayableMessage, message, errorCode } = getErrorInfo(error);
        const alertMessage = (displayableMessage && message) || t('DEFAULT_ERROR_MESSAGE');
        _errorMessage = alertMessage;
        _errorCode = errorCode || '';
        _isAxiosError = true;
      } else _isAxiosError = false;
      return Promise.reject(error);
    }
  );
  return { get, post, getErrorMessage, getErrorCode, getIsAxiosError };
};
const axios = Axios();
export { axios };
